<div class="row button-container">
    <div class="col-2 custom-button">
        <div *ngIf="column.includes('Enabled')" id="MinDimLevel-enableFeature-text" class="signifyBookmd rSet">Enable feature<input type="checkbox"
                [checked]="minDimLevelEnabledval" [(ngModel)]="ngModelval['Enabled']" name="Rset"
                class="primary-checkbox" id="mindimcheck" (change)="rSetChanged($event.target.checked)" />
            <label class="enable-feature" for="mindimcheck" aria-label="Enable feature">
                <span id="MinDimLevel-enableFeature-checkbox" class="extra-border-enablefeat"></span></label>
        </div>

        <!--External-->
    </div>
    <span class="col-1 aoc-tooltips" *ngIf="minDimLevelDefaultColor===false">
        <ng-template #restoreDefault>
            <div class="row app-area-container">
                <div class="col-9 title-tooltip">Restore default</div>
            </div>
        </ng-template>
    </span>
    <span class="col-1 aoc-tooltips" *ngIf="minDimLevelDefaultColor===true">
        <ng-template #restoreDefault>
            <div class="row app-area-container">
                <div class="col-9 title-tooltip">Default</div>
            </div>
        </ng-template>
    </span>

    <div class="col-8"></div>
    <div class="col-1"></div>
</div>
<div class="row unit-container">
    <div class="col-2 custom-button"></div>
    <div class="col-1"></div>
</div>


<!--Min Dim level Begins-->
<div *ngIf="column.includes('MinDimLevel') " class="row slider-container"
    [ngClass]="{'minDimdisbaled': minDimdisbaled}">
    <div id="MinDimLevel-sliderName-text" class="col-1 label signifyBookmd text-mindim dim-margin">Min. dim level</div>
    <span id="MinDimLevel-Slider-Min" class="signifyBookmd text-mindim  sliderMinValue col-1" *ngIf="!quickConfigvalue">{{MinDimLevelMin}}</span>

    <div class="col-2" *ngIf="quickConfigvalue">
        <div class="row">
            <div class="col-2"></div>
            <div class="col-2 minValMargin">
                <span id="MinDimLevel-Min-text" class=" signifyBookmd minValue"> min {{ MinDimLevelMin }}</span>
            </div>
            <div class="col-3">
                <span id="MinDimLevel-Max-text" class="signifyBookmd maxValue"> max {{ MinDimLevelMax }}</span>
            </div>
        </div>
    </div>
    <div class="col-6 curvePadding sliderCss" [ngClass]="{'sliderDisabled': sliderDisabled}" *ngIf="!quickConfigvalue">
        <ngx-slider [options]=MinDimLevelOption [(value)]=MinDimLevelVal (mouseup)="sliderEvent(formControl.value)"
            (userChangeEnd)="minDimLevelSlideValuechange($event.value)">
        </ngx-slider>
    </div>

    <span id="MinDimLevel-Slider-Max" class="signifyBookmd text-mindim  col-1 maxValueCss" *ngIf="!quickConfigvalue">{{MinDimLevelMax}}</span>
    <div class="row form-group col-3  ">
        <div class="d-flex align-items-center">
            <input id="MinDimLevel-Input" type="number" [(ngModel)]="ngModelval['MinDimLevelVal']"
                (input)="textValChanged($event.target.value, 'MinDimLevelVal')" (keypress)="numberOnly($event)"
                [ngClass]="{'showingError': inputError['MinDimLevelVal']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
                class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
                [disabled]="minDimdisbaled|| sliderDisabled" maxlength="3" />
            <p id="MinDimLevel-Slider-Unit" class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</p>
        </div>
    </div>
</div>
<!--Min Dim Level End -->
